import { IRootState } from "~/types/store/root";

export function region(store) {
   return store.region.city.content;
}

export function hasSplit(store: IRootState) {
   return store.region?.payTypes.some((el) => el.style === 'yandex-split') ?? false;
}
